<template functional>
  <v-chip
    :label="props.label"
    :small="props.small"
    :class="[
      data.class || '',
      data.staticClass || '',
    ]"
    v-bind="data.attrs"
    v-on="data.on"
  >
    <slot />
  </v-chip>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'CommonChip',

  props: {
    label: {
      type: Boolean,
      default: true,
    },
    small: {
      type: Boolean,
      default: true,
    },
  }
});
</script>
